import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { BulkActionFormComponent } from '../MonitoringBulkActionDialog/bulk-action-form.component';
import { TagModel } from '../../../../Common/Tags/models/tag.model';
import { TagsService } from '../../../../Common/Tags/services/tags.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'agpr-bulk-action-form-single-tag',
    templateUrl: './bulk-action-form-single-tag.component.html',
    styleUrls: ['./bulk-action-form-single-tag.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BulkActionFormSingleTagComponent),
            multi: true
        }],
    standalone: false
})
export class BulkActionFormSingleTagComponent extends BulkActionFormComponent implements ControlValueAccessor {
    public selectedTag: TagModel;
    public tagList$: Observable<TagModel[]>;

    constructor(public tagService: TagsService) {
        super();
        this.tagList$ = tagService.all$;
    }

    writeValue(tag: TagModel): void {
        this.selectedTag = tag;
    }

    selectTag(tag: TagModel) {
        this.onModelChange(tag);
    }
}
